import React, { Component } from 'react';
import classNames from 'classnames';
import { SvgImage } from '..';
import { warningIcon, checkIcon2, closeIcon, infoIcon, messageErrorIcon, messageSuccessIcon, messageWarningIcon } from '../../../style/images';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import { Box, Snackbar } from '@mui/material';
import { none } from '../../util';

export class Message extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      isFading: false,
      open:true
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }
  
  getIcon() {
    const type = this.props.message.messageType.toLowerCase();
    let icon;
    switch ( type ) {
      case 'confirmation':
        icon = messageSuccessIcon;
        break;
      case 'information':
        icon = infoIcon;
        break;
      case 'warning':
        icon = messageWarningIcon
        break;
      case 'error':
        icon = messageErrorIcon
        break;
      default:
        icon = warningIcon;
        break;
    }

    return <SvgImage source={ icon } className="message-icon"/>;
  }

  getContent() {
    const { messageText, messageType } = this.props.message;
    const lowerType = messageType.toLowerCase();
    switch ( lowerType ) {
      case 'warning':
        return <div className="warning-panel">
          <p className="warning-text">{ translate( 'DIALOG_TITLE_WARNING' ) }</p>
          <p className="warning-content">{ messageText }</p>
        </div>;
      case 'error':
        return <div className="warning-panel">
          <p className="warning-text">{ translate( 'DIALOG_TITLE_ERROR' ) }</p>
          <p className="warning-content">{ messageText }</p>
        </div>;
      default:
        return <p>{ messageText }</p>;
    }
  }

  onDelete = () => {this.props.onDelete( this.props.message );
    this.props.onClose()}
  
  handleClose = ()=>{
    this.setState({open:false})
  }

  render() {
    const { messageType, messageText } = this.props.message;
    const {timeout} = this.props;
    const { isFading } = this.state;
    const className = classNames( 'message', messageType, 
    { 'fading': isFading } 
    );
    
    if( !isFading && timeout > 500 ) {
      setTimeout( () => this.mounted && this.setState( { isFading: true } ), timeout );
    }
    
    return !isFading && messageText && <div className={ className }>
    { this.getIcon() } 
    { this.getContent() } 
    <Box sx={{height:"30px", width:"1px"}} border="1px solid #DBDBDB"></Box>
    <SvgImage source={ closeIcon } className="close-icon" onClick={ this.onDelete }/>
  </div>
    //  <Snackbar
    // ContentProps={{sx:{background:"transparent", boxShadow:"0px 0px 0px 0px rgba(0,0,0,0), 0px 0px 0px 0px rgba(0,0,0,0), 0px 0px 0px 0px rgba(0,0,0,0)", padding:{xs:"16px 16px 0px 16px", md:"0px"}}}}
    // style={{boxShadow:"none",alignItems:{xs:"flex-end",sm:"flex-end", md:"center"}, transform:{xs:"none",sm:"none"}, bottom:{xs:"82px",sm:"82px", md:"inherit"}, left:{xs:"0px",sm:"0px", md:"45%"}}}
    // sx={{boxShadow:"none",alignItems:{xs:"flex-end",sm:"flex-end", md:"center"}, transform:{xs:"none",sm:"none"}, bottom:{xs:"82px",sm:"82px", md:"inherit"}, left:{xs:"0px",sm:"0px", md:"45%"}}}
    // anchorOrigin={{vertical:"top", horizontal:"center"}}
    //     open={this.state.open}
    //     message= { <div className={ className }>
    //     { this.getIcon() } 
    //     { this.getContent() } 
    //     <Box sx={{height:"30px", width:"1px"}} border="1px solid #DBDBDB"></Box>
    //     <SvgImage source={ closeIcon } className="close-icon" onClick={ this.onDelete }/>
    //   </div> }
    //     autoHideDuration={3000}>
    // </Snackbar>
    

  }
}

Message.propTypes = {
  message: PropTypes.shape( {
    messageType: PropTypes.string.isRequired,
    messageText: PropTypes.string.isRequired,
    timeout: PropTypes.number
  } ),
  onDelete: PropTypes.func.isRequired
};